import {Map} from 'immutable'
import {
        SET_CLAIM_TYPE,
        SET_CLAIM_AMOUNT, SET_CLAIM_AMOUNT_TO_REFUND,
        SET_ORDER_ASSISTANCE_API_ERROR,
        SET_ORDER_SUPPORT_INFO
       } from '../constants/actionTypes.js'

const initialState = Map({
  name: '',
  email: '',
  orderId: '',
  orderType: '',
  merchantName: '',
  cardId: '',
  faceValue: '',
  cost: '',
  cardType: '',
  claimType: '',
  refundAmount: 0,
  fulfilled: false,
  fulfilledId: null,
  prevClaimAmount: 0
});

export default (state = initialState, action) => {
  switch(action.type) {
    
    case SET_CLAIM_TYPE:
      return state.set('claimType', action.payload);

    case SET_CLAIM_AMOUNT:
      return state.set('claimAmount', action.payload.claimAmount);

    case SET_ORDER_ASSISTANCE_API_ERROR:
      return state.set('orderAssistanceApiErrResponse', action.payload);

    case SET_ORDER_SUPPORT_INFO:
      return state.set('name', action.payload.name)
                  .set('email', action.payload.email)
                  .set('orderId', action.payload.orderId)
                  .set('orderType', action.payload.orderType)
                  .set('merchantName', action.payload.merchantName)
                  .set('cardId', action.payload.cardId)
                  .set('faceValue', action.payload.faceValue)
                  .set('cost', action.payload.cost)
                  .set('cardType', action.payload.cardType)
                  .set('fulfilledId', action.payload.fulfilledId)
                  .set('prevClaimAmount', action.payload.prevClaimAmount)
                  .set('orderUUID', action.payload.orderUUID);

    case SET_CLAIM_AMOUNT_TO_REFUND:
      return state.set('refundAmount', action.payload);

    default:
      return state;
  }
};
